import { WebserviceUrl } from "@tm/data/webserviceUrls"
import { ajaxAuth, createBufferedRequestFunction } from "@tm/utils"
import { Article } from "@tm/models"
import { GetLookupArticlesRequest, GetLookupArticlesResponse } from "./models"
import { LookupArticle } from "../../models"
import { mapToInternalArticle } from "./mapToInternalArticle"

export const getLookupArticlesBuffered = createBufferedRequestFunction({
    callService: getLookupArticles,
    mapServiceResponseToResponse: (response) => response,
    compareRequestsForFiltering: (a, b) => {
        return a.id === b.id
    },
})

export async function getLookupArticles(articles: Article[]): Promise<LookupArticle[]> {
    const url = `${WebserviceUrl.DmsArticles}/GetLookupArticles`

    const internalArticles = articles.map((a) => mapToInternalArticle(a))

    const body: GetLookupArticlesRequest = { articles: internalArticles }

    const data = await ajaxAuth<GetLookupArticlesResponse>({ url, body, method: "POST" })
    return data?.lookupArticles ?? []
}
